const u = navigator.userAgent
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

// 检测是否在微信小程序环境中（使用官方推荐的方法）
// 按照微信官方文档：在 WeixinJSBridgeReady 回调中使用 window.__wxjs_environment
// 或使用 wx.miniProgram.getEnv() 接口
let isWechatMiniProgram = false

// 检测是否在微信浏览器中（非小程序）
function getIsWechatBrowser() {
  return u.indexOf('MicroMessenger') > -1 && !isWechatMiniProgram
}

// 检测是否在原生 App 中（Android 或 iOS）
function getIsNativeApp() {
  return (isAndroid || isIOS) && !isWechatMiniProgram && !getIsWechatBrowser()
}

// 初始化值（必须在函数定义之后）
let isWechatBrowser = getIsWechatBrowser()
let isNativeApp = getIsNativeApp()

// 官方推荐方法：在 WeixinJSBridgeReady 回调中检测
function detectWechatMiniProgram() {
  // 方法1: 检查 __wxjs_environment（官方推荐，最可靠的方法）
  // 注意：只有在小程序 webview 中，这个值才会是 'miniprogram'
  // 在普通浏览器中，即使引入了 jweixin-1.3.2.js，这个值也不会是 'miniprogram'
  if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    console.log('[Bridge] 检测到微信小程序环境 (通过 __wxjs_environment)')
    isWechatMiniProgram = true
    updateEnvInfo()
    return true
  }
  
  // 方法2: 使用 wx.miniProgram.getEnv()（官方推荐方法）
  // 注意：只有在 window.__wxjs_environment === 'miniprogram' 时，才调用这个方法
  // 因为 jweixin-1.3.2.js 在非小程序环境中也会注入 wx.miniProgram，但 getEnv 可能不可用
  if (typeof wx !== 'undefined' && wx.miniProgram && wx.miniProgram.getEnv) {
    try {
      wx.miniProgram.getEnv((res) => {
        if (res && res.miniprogram === true) {
          console.log('[Bridge] 检测到微信小程序环境 (通过 wx.miniProgram.getEnv())')
          isWechatMiniProgram = true
          updateEnvInfo()
        }
      })
    } catch (e) {
      console.warn('[Bridge] wx.miniProgram.getEnv() 调用失败:', e)
    }
  }
  
  // 方法3 和 4 不再使用，因为 jweixin-1.3.2.js 在非小程序环境中也会注入 wx.miniProgram
  // 只使用 window.__wxjs_environment === 'miniprogram' 作为唯一可靠判断标准
  
  // 如果之前检测到是小程序环境，但现在 __wxjs_environment 不是 'miniprogram'，则重置
  if (isWechatMiniProgram && window.__wxjs_environment !== 'miniprogram') {
    console.log('[Bridge] 重置小程序环境检测（__wxjs_environment 不是 miniprogram）')
    isWechatMiniProgram = false
    updateEnvInfo()
  }
  
  return false
}

// 更新环境信息
function updateEnvInfo() {
  isWechatBrowser = getIsWechatBrowser()
  isNativeApp = getIsNativeApp()
  
  if (window.env) {
    window.env.isWechatMiniProgram = isWechatMiniProgram
    window.env.isWechatBrowser = isWechatBrowser
    window.env.isNativeApp = isNativeApp
    window.env.platform = isWechatMiniProgram ? 'miniprogram' : (isWechatBrowser ? 'wechat' : (isAndroid ? 'android' : (isIOS ? 'ios' : 'web')))
  }
  
  // 重新初始化 bridge
  initWebViewBridge()
}

// 立即检测一次
detectWechatMiniProgram()

// 监听 WeixinJSBridgeReady 事件（官方推荐方式）
if (typeof window !== 'undefined') {
  if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
    document.addEventListener('WeixinJSBridgeReady', () => {
      console.log('[Bridge] WeixinJSBridgeReady 事件触发')
      detectWechatMiniProgram()
    }, false)
  } else {
    // 如果已经 ready，再次检测
    detectWechatMiniProgram()
  }
}


const androidFunction = (callback) => {
  console.log('#Android#')
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', function() {
      callback(window.WebViewJavascriptBridge)
    }, false)
  }
}

const iosFunction = (callback) => {
  console.log('#iOS#')
  if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

// 初始化 WebViewJavascriptBridge
function initWebViewBridge() {
  isWechatBrowser = getIsWechatBrowser()
  isNativeApp = getIsNativeApp()
  
  // 只在原生 App 环境中初始化 WebViewJavascriptBridge
  // 微信小程序环境不需要 bridge
  if (isNativeApp) {
    window.setupWebViewJavascriptBridge = isAndroid ? androidFunction : iosFunction
  } else {
    // 非原生 App 环境，提供一个安全的 bridge 函数，避免调用错误
    window.setupWebViewJavascriptBridge = function(callback) {
      console.log('当前环境不支持 WebViewJavascriptBridge')
      if (callback) {
        // 提供一个安全的空 bridge 对象，避免调用 callHandler 时报错
        callback({
          callHandler: function() {
            console.log('当前环境不支持 callHandler')
          },
          init: function() {
            console.log('当前环境不支持 init')
          }
        })
      }
    }
  }
}

// 初始化
initWebViewBridge()

// 导出环境检测变量，供其他模块使用
window.env = {
  isAndroid,
  isIOS,
  isWechatMiniProgram,
  isWechatBrowser,
  isNativeApp,
  platform: isWechatMiniProgram ? 'miniprogram' : (isWechatBrowser ? 'wechat' : (isAndroid ? 'android' : (isIOS ? 'ios' : 'web')))
}

// 延迟检测（备用方案，确保能检测到）
setTimeout(() => {
  detectWechatMiniProgram()
}, 100)

setTimeout(() => {
  detectWechatMiniProgram()
}, 500)

// 输出调试信息
console.log('[Bridge] 环境检测结果:', {
  isAndroid,
  isIOS,
  isWechatMiniProgram,
  isWechatBrowser,
  isNativeApp,
  platform: window.env.platform,
  __wxjs_environment: typeof window !== 'undefined' ? window.__wxjs_environment : 'undefined',
  wx_miniProgram: typeof wx !== 'undefined' ? (wx.miniProgram ? 'exists' : 'not exists') : 'wx undefined',
  userAgent: u
})

/**
 * 处理推送通知点击事件
 * 当用户点击推送通知时，原生会调用此方法
 * 检查用户是否为蘑菇房用户，如果是则跳转到蘑菇房页面
 * @param {string} notificationData - 推送通知数据JSON字符串
 */
// window.notifyToH5CMD = function(notificationData) {
//   console.log('=== notifyToH5CMD 被调用 ===')
//   console.log('收到推送通知点击事件，数据:', notificationData)
//   console.log('数据类型:', typeof notificationData)
//   console.log('参数数量:', arguments.length)
//
//   // 解析通知数据
//   let notification = null
//   if (notificationData) {
//     try {
//       notification = JSON.parse(notificationData)
//       console.log('解析后的通知数据:', notification)
//     } catch (error) {
//       console.error('解析通知数据失败:', error)
//       console.log('原始数据:', notificationData)
//     }
//   }
//
//   // 获取Vue实例和路由
//   const app = document.querySelector('#app').__vue__
//   console.log('Vue应用实例:', app)
//
//   if (!app) {
//     console.warn('Vue应用实例未找到，等待页面加载...')
//     // 如果Vue实例还没准备好，等待一段时间再重试
//     setTimeout(() => {
//       const retryApp = document.querySelector('#app').__vue__
//       if (retryApp) {
//         console.log('重试获取Vue实例成功')
//         handleNotificationJump(retryApp, notification)
//       } else {
//         console.error('重试后仍未找到Vue实例')
//       }
//     }, 2000)
//     return
//   }
//
//   handleNotificationJump(app, notification)
// }

/**
 * 处理通知跳转逻辑
 */
// function handleNotificationJump(app, notification) {
//   const router = app.$router
//   const store = app.$store
//
//   console.log('路由实例:', router)
//   console.log('Store实例:', store)
//
//   // 检查用户信息
//   const userInfo = store.getters.userInfo
//   console.log('用户信息:', userInfo)
//   console.log('是否为蘑菇房用户:', userInfo && userInfo.isMushroomUser === 1)
//
//   if (userInfo && userInfo.isMushroomUser === 1) {
//     console.log('用户是蘑菇房用户，准备跳转...')
//     // 延迟1秒后跳转到蘑菇房页面，确保页面完全加载
//     setTimeout(() => {
//       console.log('执行跳转到蘑菇房页面')
//       try {
//         router.push('/mush')
//         console.log('跳转命令已执行')
//       } catch (error) {
//         console.error('跳转失败:', error)
//       }
//     }, 1000)
//   } else {
//     console.log('用户不是蘑菇房用户，不进行跳转')
//   }
// }

// 只在原生 Android App 环境中初始化 bridge
if (isAndroid && isNativeApp) {
  window.setupWebViewJavascriptBridge(function(bridge) {
    if (bridge) {
      // 注册 H5 界面的默认接收函数（与安卓交互时，不注册这个事件无法接收回调函数）
      bridge.init(function(msg, responseCallback) {
        console.log('收到原生消息:', msg)
        if (responseCallback) {
          responseCallback('J callback N')
        }
      })
    }
  })
}
